import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
const {getUrl} = Util;
import Trading from "@/assets/images/academy/tradingbg.png"
import Tradingdown from "@/assets/images/academy/downloadtrading.png"
import Tradingbg from "@/assets/images/academy/tradingbgs.png"



// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Tradings: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;

  return (
    <div className={cx(styles.trading, className)} style={{ backgroundImage: `url(${isMobile ? Tradingbg : Trading})` }}>
      <div className={cx(styles.tradingcontent, className)}>
        <h2>Trading</h2>
        <h5>As you would with fiat currencies, trading is just as common in the crypto world.</h5>
        <div className={cx(styles.learns, className)}>
          <a href={getUrl("/trade")}>
            <p>Learn more</p>
          </a>
        </div>
    </div>
    </div>
  );
};

export default observer(Tradings);
// export default Main;
